import { Maybe, Nullable } from '@/types/index';

export type AnalysisConfig = {
  enabled: Nullable<boolean>;
  consent_required: Nullable<boolean>;
  consent_required_regions?: Maybe<ConsentRequiredRegionsConfig>;
};

export enum UIVersion {
  V1 = 'v1',
  V2 = 'v2',
}

type ConsentRequiredRegionsConfig = {
  require?: string[];
  except?: string[];
};
